import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { BidRepository, type CreateBidParams } from '../../infra/BidRepository'

export type CreateBidFactoryDependencies = {
  bidRepository: BidRepository
}

export function createBidFactory({ bidRepository }: CreateBidFactoryDependencies) {
  return function createBidImpl(params: CreateBidParams) {
    return bidRepository.createBid(params)
  }
}

export function createBid(params: CreateBidParams) {
  const httpClient = new HttpClient(API_URL)
  const bidRepository = new BidRepository({ httpClient })
  const newCreateBid = createBidFactory({ bidRepository })

  return newCreateBid(params)
}
